module.exports = __webpack_public_path__ + "img/1554648866.1efe2a43.jpg";